import { render, staticRenderFns } from "./ExchangeEmployeesPlanning.vue?vue&type=template&id=681fa16f&scoped=true"
import script from "./ExchangeEmployeesPlanning.vue?vue&type=script&lang=js"
export * from "./ExchangeEmployeesPlanning.vue?vue&type=script&lang=js"
import style0 from "./ExchangeEmployeesPlanning.vue?vue&type=style&index=0&id=681fa16f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681fa16f",
  null
  
)

export default component.exports